import { useQuery } from '@tanstack/react-query'
import { useCurrentNetwork } from '@mysten/dapp-kit-react'

import { useBackendClient } from '@/shared/kai/contexts/BackendClientContext'
import {
  OrderType,
  OwnersResponseType,
  OwnersSortByType,
  TimeFilterType,
} from '@/shared/backend/types/leaderboard'

export const leaderboardOwnersQueryKey = (
  network: string,
  sortBy: OwnersSortByType,
  order: OrderType,
  timeFilter: TimeFilterType
) => ['leaderboard-owners', network, sortBy, order, timeFilter] as const

type OwnerType = OwnersResponseType[number]

export interface OwnersResponseTypeWithRank extends OwnerType {
  rank: number
}

export const useLeaderboardOwners = (
  hydrated: boolean,
  sortBy: OwnersSortByType,
  order: OrderType,
  timeFilter: TimeFilterType
) => {
  const network = useCurrentNetwork()

  const backendClient = useBackendClient()

  const result = useQuery({
    enabled: hydrated,
    queryKey: leaderboardOwnersQueryKey(network, sortBy, order, timeFilter),
    queryFn: async () => {
      return await backendClient.leaderboardGetOwners(sortBy, order, timeFilter)
    },
    staleTime: 1 * 60 * 1000, // 1 minute
    refetchInterval: 1 * 60 * 1000, // 1 minute
  })

  return {
    isLoading: result.isLoading,
    isError: result.isError,
    data: result.data?.map((d, i) => ({
      ...d,
      rank: i + 1,
    })),
  }
}
